import { Component } from '@angular/core';

import { register } from 'swiper/element/bundle';

import {
  ContextMenuComponent,
  MainMenuComponent,
  Menu,
  MenuComponent,
  MenuIcon,
  MenuItemComponent,
  NavigationComponent,
  QuickActionsComponent,
  ToggleNavigationComponent,
} from '@camelot/menu';

import { TestIdDirective } from '@camelot/testing-harness';

register();

function buildMenu(): Menu {
  return new Menu({
    elements: [
      new MenuIcon({ icon: 'edit', key: 'first', label: 'First' }),
      new MenuIcon({ icon: 'add', key: 'second', label: 'Second' }),
    ],
  });
}

@Component({
    imports: [
        ContextMenuComponent,
        MainMenuComponent,
        MenuComponent,
        MenuItemComponent,
        NavigationComponent,
        QuickActionsComponent,
        TestIdDirective,
        ToggleNavigationComponent,
    ],
    template: `
    <cam-menu camTestId="cam-menu" [menu]="this.menu" container="main" />
    <cam-menu-item camTestId="cam-menu-item" [item]="this.item" />
    <cam-main-menu camTestId="cam-main-menu" [menuMain]="this.menu" [menuUser]="this.userMenu" />
    <cam-quick-actions camTestId="cam-quick-actions" [menu]="this.menu" />
    <cam-toggle-navigation camTestId="cam-toggle-navigation" [menu]="this.menu" container="tab" />
    <cam-context-menu camTestId="cam-context-menu" [menu]="this.menu" />
    <cam-menu-navigation camTestId="cam-menu-navigation" [menu]="this.menu" container="tab" />
  `
})
export class MenuCase {
  public item = new MenuIcon({ icon: 'edit', key: 'item', label: 'Item' });
  public menu = buildMenu();
  public userMenu = buildMenu();
}
